import { render, staticRenderFns } from "./GoogleCallback.vue?vue&type=template&id=0d23a29d&scoped=true&"
import script from "./GoogleCallback.vue?vue&type=script&lang=js&"
export * from "./GoogleCallback.vue?vue&type=script&lang=js&"
import style0 from "./GoogleCallback.vue?vue&type=style&index=0&id=0d23a29d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23a29d",
  null
  
)

export default component.exports